import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.farm.widget.modal.cage.supply');
import { OnInit, Input, Output, EventEmitter, SimpleChanges, ViewChild, HostListener, ChangeDetectorRef } from '@angular/core';
import moment from 'moment';

@Component({
    selector: 'wiz-portal-farm-widget-modal-cage-supply',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.farm.widget.modal.cage.supply/view.scss */
/* src/app/portal.farm.widget.modal.cage.supply/view.scss: no such file or directory */`],
})
export class PortalFarmWidgetModalCageSupplyComponent implements OnInit {

    @ViewChild('modalMessage') modalMessage: any;

    @Input() data: any;
    @Output() closed = new EventEmitter<any>();

    public closing = false;

    public form = {
        date: '',
        feed: 0,
        feed_price: 0,
        water: 0
    };

    constructor(@Inject( ChangeDetectorRef) private cdr: ChangeDetectorRef) {}

    ngOnInit(): void {
        this.initialize();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['data']) {
            this.initialize();
        }
    }

    @HostListener('document:keydown.escape')
    onEscKey() {
        if (!this.closing) this.cancel();
    }

    private initialize(): void {
        const today = moment().format('YYYY-MM-DD');

        const defaults = {
            date: today,
            feed: 0,
            feed_price: 0,
            water: 0
        };

        let data = { ...(this.data || {}) };

        if (data.date) {
            data.date = moment(data.date).format('YYYY-MM-DD');
        }

        this.form = {
            ...defaults,
            ...data
        };
    }

    private showModal(message: string) {
        this.modalMessage.open({ message });
    }

    private closeWithAnimation(value: any) {
        if (this.closing) return;
        this.closing = true;
        this.cdr.detectChanges();
        setTimeout(() => {
            this.closed.emit(value);
        }, 150);
    }

    public register(): void {
        if (!this.form.water && !this.form.feed) {
            this.showModal("급이량 또는 급수량을 입력해주세요.");
            return;
        }
        this.closeWithAnimation(this.form);
    }

    public cancel(): void {
        this.closeWithAnimation(null);
    }
}

export default PortalFarmWidgetModalCageSupplyComponent;